import React from "react";

const icon = ({
  d,
  fillcolor,
  cx,
  cy,
  r,
  stroke,
  cxone,
  cyone,
  rone,
  strokeWidth,
  fillRule,
  cxtwo,
  cytwo,
  rtwo,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      style={{ cursor: "pointer" }}
    >
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <circle
          cx={cx}
          cy={cy}
          r={r}
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={cxone}
          cy={cyone}
          r={rone}
          fill={fillcolor}
          fillRule={fillRule}
        />
        <circle
          cx={cxtwo}
          cy={cytwo}
          r={rtwo}
          fill={fillcolor}
          fillRule={fillRule}
        />
        <path
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          d={d}
        />
      </g>
    </svg>
  );
};

export default icon;
